var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerFireboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu (22) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.981,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5442 4.75827C14.5754 4.75185 9.60668 4.75827 4.63797 4.77747C3.79596 5.01146 3.50693 5.47886 3.77079 6.17962C3.95018 6.48034 4.23925 6.666 4.63797 6.73664C9.60672 6.76227 14.5755 6.76227 19.5442 6.73664C20.3862 6.50266 20.6753 6.03526 20.4114 5.33449C20.2242 5.03324 19.9351 4.84117 19.5442 4.75827Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.981,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5442 10.7583C14.5754 10.7519 9.60668 10.7583 4.63797 10.7775C3.79596 11.0115 3.50693 11.4789 3.77079 12.1796C3.95018 12.4803 4.23925 12.666 4.63797 12.7366C9.60672 12.7623 14.5755 12.7623 19.5442 12.7366C20.3862 12.5027 20.6753 12.0353 20.4114 11.3345C20.2242 11.0332 19.9351 10.8412 19.5442 10.7583Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.978,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3711 16.7563C9.79295 16.7499 7.21483 16.7563 4.63675 16.7755C3.79473 17.0095 3.5057 17.4769 3.76956 18.1777C3.94895 18.4784 4.23803 18.664 4.63675 18.7347C7.21488 18.7603 9.793 18.7603 12.3711 18.7347C13.2103 18.479 13.4837 17.9988 13.1914 17.2941C12.9928 17.035 12.7194 16.8557 12.3711 16.7563Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerFireboard);
export default __webpack_public_path__ + "static/media/hamburgerFireboard.6d321a060d25d8417783111968f8d87a.svg";
export { ForwardRef as ReactComponent };